import { useQuery, UseQueryOptions, QueryClient } from 'react-query'
import { BigNumber } from 'bignumber.js'
import { getCrc20Contract } from 'utils/contractHelpers'
import { isNilOrUndef } from 'utils/isNilOrUndef'
import { QueryKey } from 'config/constants/queryKey'

export const queryKeyLpTokenBalanceOf = (tokenAddress: string, targetAddress: string) => [
  QueryKey.TOKEN_BALANCE_QUERY,
  tokenAddress,
  targetAddress,
]
const queryFnLpTokenBalanceOf = async (tokenAddress: string, targetAddress: string) => {
  if (isNilOrUndef(targetAddress) || isNilOrUndef(tokenAddress)) {
    return undefined
  }
  const contract = getCrc20Contract(tokenAddress)
  const res = await contract.balanceOf(targetAddress)
  return new BigNumber(res.toString())
}
export const useLpTokenBalanceOf = (
  tokenAddress: string,
  targetAddress: string,
  queryOptions?: Omit<UseQueryOptions<BigNumber, unknown, BigNumber, string[]>, 'queryFn' | 'queryKey'>,
) => {
  return useQuery(
    queryKeyLpTokenBalanceOf(tokenAddress, targetAddress),
    () => queryFnLpTokenBalanceOf(tokenAddress, targetAddress),
    queryOptions,
  )
}
export const queryLpTokenBalanceOf = (queryClient: QueryClient, tokenAddress: string, targetAddress: string) =>
  queryClient.fetchQuery(queryKeyLpTokenBalanceOf(tokenAddress, targetAddress), () =>
    queryFnLpTokenBalanceOf(tokenAddress, targetAddress),
  )
